export default {
  operatedBy: 'Uitgevoerd door',
  partlyOperatedBy: 'Gedeeltelijk uitgevoerd door',
  operatedByGerman: '',
}
